import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

export interface InvoiceHistoryOrderList {
    invoiceNo: string;
    invoiceDate: string;
    status: string;
    invoiceTotal: string;
    orderLines?: string;
    poLines: PoLinesShippedWithQuantity[];
    customerNumber: string;
}

export interface PoLinesShippedWithQuantity {
    key: string;
    value: string;
}

export interface InvoiceHistoryOrderListParameter extends ApiParameter {
    orderId: string;
    customerNumber: string;
}

export const url = "/api/v2/invoices";

export async function getInvoiceHistoryOrderList(parameter: InvoiceHistoryOrderListParameter) {
    try {
        const result = await get<InvoiceHistoryOrderList[]>(
            `${url}?orderNumber=${parameter.orderId}&customerNumber=${parameter.customerNumber}`,
        );
        return result;
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
